import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ComplianceChart = ({ data }) => {
  return (
    <div className="w-full h-80" aria-label="Compliance Trend Chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            dataKey="month" 
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
            domain={[0, 100]}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px'
            }}
          />
          <Legend 
            wrapperStyle={{ fontSize: '12px' }}
          />
          <Line 
            type="monotone" 
            dataKey="compliance" 
            stroke="var(--color-success)" 
            strokeWidth={2}
            name="Compliance Rate (%)"
            dot={{ fill: 'var(--color-success)', r: 4 }}
          />
          <Line 
            type="monotone" 
            dataKey="target" 
            stroke="var(--color-warning)" 
            strokeWidth={2}
            strokeDasharray="5 5"
            name="Target (%)"
            dot={{ fill: 'var(--color-warning)', r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ComplianceChart;